// Keep this role list aligned with app/services/billing/billing_service.py.
export const BILLING_ACCESS_ENFORCED_ROLES = Object.freeze([
  "admin",
  "owner",
  "independent_professional",
]);

export function isBillingBypassedForSuperAdmin(user) {
  return Boolean(user?.is_super_admin || user?.superadmin_mode);
}

export function isBillingEnforcedRole(role) {
  return BILLING_ACCESS_ENFORCED_ROLES.includes(String(role || "").toLowerCase());
}

export function shouldRequireBillingAccess(role, user) {
  return (
    !isBillingBypassedForSuperAdmin(user) &&
    isBillingEnforcedRole(role) &&
    user?.billing_access_granted === false
  );
}
